export { ContentTypeService } from './content-type.service';